/*
 * Ryan O'Dowd
 * 2025-01-01
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({fonts, colors, globalScale, isDarkMode}) => {
  return {
    headerRow: {
      backgroundColor: isDarkMode ? colors.primaryExtraDark : colors.white,
      borderTopLeftRadius: globalScale * 6,
      borderTopRightRadius: globalScale * 6,
      padding: 0,
      minWidth: 'fit-content',
    },
    headerCell: {
      display: 'flex',
      alignItems: 'center',
      padding: globalScale * 4,
    },
    textStyle: (rightAlign, isSelected) => {
      const styles = {
        fontFamily: fonts.primaryBold,
        fontSize: globalScale * 12,
        maxHeight: 'initial',
        color: isDarkMode ? colors.primaryExtraLight : colors.primaryExtraDark,
        padding: globalScale * 4,
        textAlign: rightAlign ? 'right' : 'left',
      };

      if (isSelected) {
        styles.color = isDarkMode ? colors.white : colors.primary;
      }

      return styles;
    },
  };
};

export default getStyles;
